

import { NWDividerAdapter } from "@/wc/components/base/nw-divider/adapter.ts";
import { NWNoteAdapter } from "@/wc/editor/components/nw-note/adapter.ts";

import { NWAnchorAdapter } from "@/wc/editor/components/nw-anchor/adapter.ts";
import { NWQuizAdapter } from "@/wc/editor/components/nw-quiz/adapter.ts";
import { NWTabAdapter, NWTabsAdapter } from "@/wc/editor/components/nw-tabs/adapter.ts";
import { NWVariableAdapter } from "@/wc/editor/components/nw-variable/adapter.ts";
import { NWCheckboxAdapter } from "@/wc/editor/components/nw-checkbox/adapter.ts";

import { NWContentLinkAdapter } from "@/wc/editor/components/nw-content-link/adapter.ts";
import { NWImageAdapter } from "@/wc/editor/components/nw-image/adapter.ts";
import { NWSectionAdapter } from "@/wc/editor/components/nw-section/adapter.ts";
import { NWStepAdapter } from "@/wc/editor/components/nw-step/adapter.ts";

import { ListItemAdapter } from "./listItem.ts";
import { NWCodeAdapter, NWCodeBlockAdapter } from "@/wc/editor/components/nw-code-block/adapter.ts";
import { NWValidationBoxAdapter } from "../components/validations/nw-validation-box/adapter.ts";
import { NWValidationTextAdapter } from "../components/validations/nw-validation-text/adapter.ts";
import { NWValidationUrlAdapter } from "../components/validations/nw-validation-url/adapter.ts";
import { NWValidationUploadAdapter } from "../components/validations/nw-validation-upload/adapter.ts";

export default [
  ListItemAdapter,
  NWStepAdapter,
  NWImageAdapter,
  NWDividerAdapter,
  NWCodeAdapter,
  NWCodeBlockAdapter,
  NWValidationBoxAdapter,
  NWValidationTextAdapter,
  NWValidationUrlAdapter,
  NWValidationUploadAdapter,
  NWNoteAdapter,
  NWSectionAdapter,
  NWCheckboxAdapter,
  NWContentLinkAdapter,
  NWTabsAdapter,
  NWTabAdapter,
  NWAnchorAdapter,
  NWVariableAdapter,
  NWQuizAdapter,
];
